module.exports = __webpack_public_path__ + "img/training-report-enable.79dafe54.svg";